import { compose, composeU } from '@yandex-int/hr-components/lib/compose';
import {
    Button as BaseButton,
    withBaseline,
    withSizeL,
    withSizeS,
    withWidthMax,
} from '@yandex-int/hr-components/Button';

import { withViewLegalSecondary } from "./Button_view_legal_secondary";

export const Button = compose(
    composeU(
        withViewLegalSecondary
    ),
    composeU(withSizeL, withSizeS),
    composeU(withBaseline, withWidthMax),
)(BaseButton);
